import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { AppService } from '@ui-components/services';

@Injectable()
export class OrgIdInterceptor implements HttpInterceptor {

  constructor(private app_service: AppService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.app_service.selectedManagementGroup$.pipe(
      take(1),
      switchMap(selectedGroup => {
        const selectedOrgId = selectedGroup?.id;

        if (selectedOrgId) {
          if (req.method === 'POST' || req.method === 'PUT') {
            if (isPlainObject(req.body)) {
              const clonedRequest = req.clone({
                body: {
                  ...req.body as Record<string, unknown>,
                  org_id: Number(selectedOrgId),
                }
              });
              return next.handle(clonedRequest);
            }
          }

          if (req.method === 'GET') {
            const clonedRequest = req.clone({
              setParams: {
                org_id: String(selectedOrgId),
              }
            });
            return next.handle(clonedRequest);
          }
        }

        return next.handle(req);
      })
    );
  }
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return Object.prototype.toString.call(value) === '[object Object]';
}
